import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getRegistroRetiros = async (fechaStart,fechaEnd , idRecolector) => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/retiro?empresa=${userInfo.empresa}&fechaStart=${fechaStart}&fechaEnd=${fechaEnd}&idRecolector=${idRecolector}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const crearRegistroRetiro = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        
        const {data}  = await Axios.post(
            '/retiro', clienteData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updateRegistroRetiro = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        const {data}  = await Axios.patch(
          `/retiro/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const deleteRegistroRetiro = (Id) => Axios.delete(`/retiro/${Id}`);